// extracted by mini-css-extract-plugin
var _1 = "MyUnreadEmailsWidgetItemContent-moduleMyUnreadEmailsWidgetItemContent__AvpWS";
var _2 = "MyUnreadEmailsWidgetItemContent-moduleaccountInfoContainer__pc1B9";
var _3 = "MyUnreadEmailsWidgetItemContent-moduleaccountType__xqb41 ListItemContent-moduledescription__jaeCE";
var _4 = "MyUnreadEmailsWidgetItemContent-moduletext__5edIK ListItemContent-moduletext__Rd9WF";
export { _1 as "MyUnreadEmailsWidgetItemContent", _2 as "accountInfoContainer", _3 as "accountType", _4 as "text" }
